export class WorksheetDesign {
  id: number
  name: string

  constructor(data) {
    this.id = data.id
    this.name = data.name
  }
}
